import {
  SETTINGS_JOBTYPE_CLEAR_SNACKBAR,
  SETTINGS_GET_JOBTYPE,
  SETTINGS_GET_JOBTYPE_LOADING,
  SETTINGS_DELETE_JOBTYPE_SUCCESS,
  SETTINGS_ADD_JOBTYPE_SUCCESS,
  SETTINGS_ADD_JOBTYPE_ERROR,
  SETTINGS_JOBTYPE_ERROR,
} from "../constants/types";

const initialState = {
  jobType: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const jobTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_JOBTYPE_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case SETTINGS_GET_JOBTYPE:
      return {
        ...state,
        ...action.payload,
        showSnackbar: false,
      };
    case SETTINGS_GET_JOBTYPE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SETTINGS_DELETE_JOBTYPE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_JOBTYPE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_JOBTYPE_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_JOBTYPE_ERROR:
      return {
        ...state,
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };

    default:
      return state || {};
  }
};

export default jobTypeReducer;
